import React from 'react';
import { TitlePageH1 } from '@tap/mui-ui';
import { Grid, Box } from '@mui/material';
import { IssueFilter, defaultFilterValue } from './search-page-ui/IssueFilter';
import { useIssueTable, IssueTable } from './search-page-ui/IssueTable';

/**
 *  Сменно-суточные задания
 */

type IIssueSearchPageProps = {
    title?: string,
}


const filterProviderProps = {
    useQueryParams: true,
    defaultValue: defaultFilterValue,
};

export const IssueSearchPage = IssueFilter.withProvider(filterProviderProps, ({ title }: IIssueSearchPageProps) => {

    const [columns, rows, rawDataState] = useIssueTable([]);


    return (
        <>
            <TitlePageH1>{title}</TitlePageH1>

            {/* Основной контент */}
            <Box sx={{ pt: 3, pb: 0 }}>
                <Grid container
                    spacing={2}
                    alignItems='flex-start'
                    sx={{ maxWidth: '1350px' }}>
                    {/* Таблица, в зависимости от выбранной табы */}
                    <Grid item
                        md={8}
                        xs={12}>
                        <IssueTable
                            columns={columns}
                            rows={rows}
                            rawDataState={rawDataState}
                            showFilter={false}
                        />
                    </Grid>


                    <Grid container
                        item
                        md={4}
                        xs={12}
                        alignItems='flex-start'
                        spacing={2}>

                        {/* Фильтр */}
                        <IssueFilter.Component />
                    </Grid>
                </Grid>
            </Box >
        </>
    );
});
